(() => {
    document.addEventListener('alpine:init', () => {
      // Linked Products variant switching
      Alpine.data('LinkedProducts', (type) => ({
        linkedProductsType: '',
        $section: null,
        $products: [],
        products: [],
        hasSpecs: false,
        init() {
          let am = this;
          am.linkedProductsType = type;
  
          document.addEventListener('init-LinkedProducts', (e) => {
            if (am.$section) return;
  
            am.$section = e.target;
            am.$products = [...am.$section.querySelectorAll('[data-linked-product]')];
  
            // init products on page load
            (async () => {
              let px_products = am.$products.map(($item) => {
                let handle = $item.dataset.linkedProduct;
                return fetch(`/products/${handle}.js`).then(res => res.json());
              });
  
              am.products = await Promise.all(px_products);
              am.UpdateLinkedProductUrls();
            })();
          });
          subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
            am.UpdateLinkedProductUrls(e.data.variant.options);
          });
        },
  
        UpdateLinkedProductUrls(current_values) {
          let am = this;
  
          if (!am.products.length) return;
  
          am.$products.forEach(($product) => {
            let handle = $product.dataset.linkedProduct;
            let product = am.products.find(p => p.handle == handle);
  
            if (!product) return;
  
            if (!current_values) {
              current_values = JSON.parse($product.dataset.current_values);
            }
  
            let optionIdsToMatch = [1, 2, 3];
            if (am.linkedProductsType) {
              // exclude option from matching
              optionIdsToMatch = optionIdsToMatch.filter((id) => product.options.map(opt => opt.name).indexOf(am.linkedProductsType) !== (id - 1));
              //console.log(optionIdsToMatch);
            }
  
            let valuesToMatch = optionIdsToMatch.map((id) => current_values[(id - 1)]);
  
            let matching_variant = product.variants.find((v) => {
              let v_options = optionIdsToMatch.map((id) => v[`option${id}`]).join('/');
              return v_options == valuesToMatch.join('/')
            });
            if (!matching_variant) return;
            $product.setAttribute('href', `/products/${handle}?variant=${matching_variant.id}`);
  
            // apply soldout class if not available
            const shapeLabel = $product.querySelector('label')
            if (shapeLabel) {
              shapeLabel.classList.toggle('disabled', !(matching_variant && matching_variant.available));
            }
          });
        }
      }));
    })
  })()

  if (!customElements.get('size-drawer')) {
    customElements.define(
      'size-drawer',
      class SizeDrawer extends HTMLElement {
        constructor() {
          super();
          
          this.onBodyClick = this.handleBodyClick.bind(this);
          
          // Set up the close button listener
          const closeButton = this.querySelector('.size-drawer-button');
          if (closeButton) {
            closeButton.addEventListener('click', () => {
              this.hide();
            });
          }
          
          // Close on ESC key
          this.addEventListener('keyup', (event) => {
            if (event.code.toUpperCase() === 'ESCAPE') this.hide();
          });
        }
        
        handleBodyClick(evt) {
          const target = evt.target;
          if (
            target != this &&
            !target.closest('size-drawer') &&
            target.id != 'ShowSizeDrawer'
          ) {
            this.hide();
          }
        }
        
        hide() {
          this.removeAttribute('open');
          document.body.removeEventListener('click', this.onBodyClick);
          document.body.classList.remove('overflow-hidden');
          
          // If you have focus trapping (from Dawn theme)
          if (typeof removeTrapFocus === 'function' && this.focusElement) {
            removeTrapFocus(this.focusElement);
          }
        }
        
        show(focusElement) {
          console.log('show size drawer');
          this.focusElement = focusElement;
          this.setAttribute('open', '');
          document.body.addEventListener('click', this.onBodyClick);
          document.body.classList.add('overflow-hidden');
          
          // If you have focus trapping (from Dawn theme)
          if (typeof trapFocus === 'function') {
            trapFocus(this);
          }
        }
      }
    );
  }
  
  if (!customElements.get('size-drawer')) {
    customElements.define(
      'size-drawer',
      class SizeDrawer extends HTMLElement {
        constructor() {
          super();
          
          this.onBodyClick = this.handleBodyClick.bind(this);
          
          // Set up the close button listener
          const closeButton = this.querySelector('.size-drawer-button');
          if (closeButton) {
            closeButton.addEventListener('click', () => {
              this.hide();
            });
          }
          
          // Close on ESC key
          this.addEventListener('keyup', (event) => {
            if (event.code.toUpperCase() === 'ESCAPE') this.hide();
          });
        }
        
        handleBodyClick(evt) {
          const target = evt.target;
          if (
            target != this &&
            !target.closest('size-drawer') &&
            !target.closest('size-chart-trigger')
          ) {
            this.hide();
          }
        }
        
        hide() {
          this.removeAttribute('open');
          document.body.removeEventListener('click', this.onBodyClick);
          document.body.classList.remove('overflow-hidden');
        }
        
        show(focusElement) {
          this.setAttribute('open', '');
          document.body.addEventListener('click', this.onBodyClick);
          document.body.classList.add('overflow-hidden');
        }
      }
    );
  }
  
  if (!customElements.get('size-chart-trigger')) {
    customElements.define(
      'size-chart-trigger',
      class SizeChartTrigger extends HTMLElement {
        constructor() {
          super();

          // Get the button inside the trigger element
          const button = this.querySelector('button');

          if (button) {
            // Add click event to trigger button
            button.addEventListener('click', (evt) => {
              evt.preventDefault();
              evt.stopPropagation();

              // Try multiple ways to find the drawer
              let sizeDrawer = null;

              // First try to find it as a sibling
              sizeDrawer = this.parentNode.querySelector('size-drawer');

              // If not found, try the whole document
              if (!sizeDrawer) {
                sizeDrawer = document.querySelector('size-drawer');
              }

              if (sizeDrawer) {
                console.log('Found size drawer, showing it');
                sizeDrawer.show(button);
              } else {
                console.error('Size drawer not found');
              }
            });
          }
        }
      }
    );
  }

  if (!customElements.get('yardage-drawer')) {
    customElements.define(
      'yardage-drawer',
      class YardageDrawer extends HTMLElement {
        constructor() {
          super();

          this.onBodyClick = this.handleBodyClick.bind(this);

          // Set up the close button listener
          const closeButton = this.querySelector('.yardage-drawer-button');
          if (closeButton) {
            closeButton.addEventListener('click', () => {
              this.hide();
            });
          }

          // Close on ESC key
          this.addEventListener('keyup', (event) => {
            if (event.code.toUpperCase() === 'ESCAPE') this.hide();
          });
        }

        handleBodyClick(evt) {
          const target = evt.target;
          if (
            target != this &&
            !target.closest('yardage-drawer') &&
            !target.closest('yardage-trigger')
          ) {
            this.hide();
          }
        }

        hide() {
          this.removeAttribute('open');
          document.body.removeEventListener('click', this.onBodyClick);
          document.body.classList.remove('overflow-hidden');

          if (typeof removeTrapFocus === 'function' && this.focusElement) {
            removeTrapFocus(this.focusElement);
          }
        }

        show(focusElement) {
          this.focusElement = focusElement;
          this.setAttribute('open', '');
          document.body.addEventListener('click', this.onBodyClick);
          document.body.classList.add('overflow-hidden');

          if (typeof trapFocus === 'function') {
            trapFocus(this);
          }
        }
      }
    );
  }

  if (!customElements.get('yardage-trigger')) {
    customElements.define(
      'yardage-trigger',
      class YardageTrigger extends HTMLElement {
        constructor() {
          super();

          const button = this.querySelector('button');

          if (button) {
            button.addEventListener('click', (evt) => {
              evt.preventDefault();
              evt.stopPropagation();

              let yardageDrawer = null;

              // First try to find it as a sibling
              yardageDrawer = this.parentNode.querySelector('yardage-drawer');

              // If not found, try the whole document
              if (!yardageDrawer) {
                yardageDrawer = document.querySelector('yardage-drawer');
              }

              if (yardageDrawer) {
                yardageDrawer.show(button);
              } else {
                console.error('Yardage drawer not found');
              }
            });
          }
        }
      }
    );
  }